import { Fragment } from 'react';

import { Divider } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';

import { CmsQuestRequirement } from 'components/quests/cms-hooks/types';
import { IQuest } from 'components/quests/loyalty-quest/types';
import { Tier } from 'components/quests/loyalty-quest/utils';
import { LoyaltyQuestStepStatus } from 'generated/graphql-gateway';
import { ILoyaltyQuestsUiDetailFragment } from 'generated/sanity-graphql';
import { spacing } from 'styles/constants';

import { EarnCrownsBadge } from '../earn-crowns-badge';
import { LockedQuestStep } from '../locked-step';
import { QuestStep } from '../quest-step';

interface ITieredStepsProps {
  quest: IQuest;
  tiers: Tier[];
  // @TODO: Add proper type for cmsSteps
  cmsSteps: any;
  cmsQuestRequirementById: CmsQuestRequirement;
  cmsQuestDetailUI: ILoyaltyQuestsUiDetailFragment;
  onCloseDrawer: () => void;
}

export const TieredSteps = ({
  tiers,
  quest,
  cmsSteps,
  cmsQuestRequirementById,
  cmsQuestDetailUI,
  onCloseDrawer,
}: ITieredStepsProps) => {
  const firstUncompletedTierIndex = tiers.findIndex(
    tier => tier.status === LoyaltyQuestStepStatus.NOT_COMPLETED
  );

  return (
    <View style={styles.container}>
      {tiers.map((tier, tierIndex) => {
        return (
          <Fragment key={tierIndex}>
            {tierIndex > 0 && <Divider />}
            <View style={styles.availableTierContainer}>
              <EarnCrownsBadge bonusPoints={tier?.bonusPoints} status={tier?.status} />
              {(tier?.steps ?? []).map((step, stepIndex) => {
                // When every tier is completed, findIndex returns -1 because no
                // NOT_COMPLETED tier exists. Without this guard the comparison
                // `tierIndex <= -1` would be false for all tiers, incorrectly
                // rendering completed progress as LockedQuestStep.
                return firstUncompletedTierIndex === -1 ||
                  tierIndex <= firstUncompletedTierIndex ? (
                  <QuestStep
                    key={stepIndex}
                    step={step}
                    quest={quest}
                    cmsStep={cmsSteps}
                    cmsQuestRequirementById={cmsQuestRequirementById}
                    cmsQuestDetailUI={cmsQuestDetailUI}
                    onCloseDrawer={onCloseDrawer}
                  />
                ) : (
                  <LockedQuestStep key={stepIndex} />
                );
              })}
            </View>
          </Fragment>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {},
  availableTierContainer: {
    gap: spacing.$4,
    paddingVertical: spacing.$4,
  },
  lockedTiersContainer: {
    gap: spacing.$4,
    paddingVertical: spacing.$4,
  },
});
